app.controller('openDocumentController',
  ['$scope', '$routeParams', '$location', 'apiHelper', 'portalHelper', 'authHelper', 'HttpAuth',
    function ($scope, $routeParams, $location, apiHelper, portalHelper, authHelper, HttpAuth) {

      portalHelper.portalReady(function () {
        const file_rel_url = '/api/document/' + $routeParams.id + '.json';
        HttpAuth.get(apiHelper.getApiUrl() + file_rel_url).then(
          function (result) {
            // RPR-6678: branch on media_type. Videos open in our own
            // Mux-based viewer at #/video/:id (registered in
            // routing_document.js). PDFs/other docs continue to use
            // PDF.js, which has no concept of HLS streaming and would
            // otherwise just download the .mp4.
            if (result.data?.media_type === 'video') {
              $location.path('/video/' + $routeParams.id);
              return;
            }
            window.location.href = apiHelper.getApiUrl() + '/static/pdfjs/index.html?title='+ encodeURIComponent(result.data.filename) +'&file=' + encodeURIComponent(result.data.file);
          },
          portalHelper.showErrorCommon
        );
      });

    }]
);